<div class="non-login-user-login-alert-popup">
  <div class="non-login-user-login-alert-popup-body">
    <!-- <div class="ipm-close-icon" (click)="close()">
      <i class="pi pi-times"></i>
    </div> -->
    <ng-container *ngIf="type === 'limitExceed'; else noLimitedUi">
      <div class="ipm-limit-exceed-section ipm-listening-dashboard-promo-container">
        <div class="popup-header">
          <div class="popup-title">Welcome to <span>Beat22</span></div>
        </div>
        <div class="popup-content">
          <div class="text-content">
            <div class="limit-message">
              <div class="limit-title"> Sign Up for Free – <span>🔓</span> Unlock Your Listening Dashboard!</div>
            </div>
            <div class="limit-explanation">
              Manage your music creation experience effortlessly. Track plays, save favorites and access downloads in one place.
            </div>
          </div>
        </div>

        <!-- Desktop Image -->
        <div class="ipm-promo-image-desktop">
          <div class="ipm-promo-image-wrapper">
            <img
              src="https://ip-dev.s3.ap-south-1.amazonaws.com/Platform+Graphics/onboarding-flow/feature/buyer+dash.webp"
              alt="Listening Dashboard"
              class="ipm-promo-img"
            >
          </div>
        </div>

        <!-- Mobile Image -->
        <div class="ipm-promo-image-mobile">
          <div class="ipm-promo-image-wrapper">
            <img
              src="assets/imgs/listening-dashboard-promo-mobile.png"
              alt="Listening Dashboard"
              class="ipm-promo-img"
            >
          </div>
        </div>

        <!-- CTA Buttons -->
        <div class="ipm-promo-content">
          <div class="ipm-promo-actions">
            <button
              class="ipm-promo-btn ipm-promo-btn-primary"
              (click)="openAuthModel('signup')"
            >
              Sign Up Now
            </button>
            <button
              *ngIf="isMusicPlayer"
              class="ipm-promo-btn ipm-promo-btn-secondary"
              (click)="close()"
            >
              Continue Listening
            </button>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-template #noLimitedUi>
      <p class="sub-heading">
        <span *ngIf="!isStartSelling">Please sign up or sign in to continue</span>
        <span *ngIf="isStartSelling">Sign up as a seller to proceed.</span>
      </p>
      <div class="actions ipm-form-actions">
        <button class="btn ipm-submit-btn" type="submit" (click)="openAuthModel('signup')">
          Sign Up
        </button>
        <button color="primary " class="btn Sign-button ipm-submit-btn" type="submit" (click)="openAuthModel('login')">
          Sign In
        </button>
      </div>
    </ng-template>
  </div>
</div>
